<template>
  <el-upload
    class="fs-bi-upload"
    ref="upload"
    :action="uploadUrl"
    :multiple="multiple"
    :before-upload="beforeUploadHandle"
    :on-progress="progressHandle"
    :on-success="successHandle"
    :on-error="errorHandle"
    :limit="fileLimit"
    :headers="uploadHeaders"
    :on-exceed="exceedHandle"
    :http-request="putUploadAjax"
    :class="{ 'upload-hide': successFileList.length >= fileLimit }"
    :show-file-list="false"
    :disabled="disabled"
  >
    <el-tooltip effect="dark" :content="content" :disabled="!Boolean(content)" placement="top-start">
      <el-button type="primary" plain v-if="showBtn">
        <i class="el-icon-upload"></i>
        {{ $t('728') }}
      </el-button>
    </el-tooltip>
    <div v-if="showFile">
      <template v-for="(item, index) in successFileList">
        <el-tag
          v-if="item.file_name"
          :key="index"
          closable
          type="primary"
          plain
          @click="handleOpen($event, item)"
          @close="handleRemove($event, item)"
        >
          <el-link :href="item.object_url" target="_blank" type="primary" plain :title="item.file_name">
            {{
              item.file_name.split('.')[0].length > maxDisplayNum
                ? item.file_name.split('.')[0].substr(0, maxDisplayNum - 3) + '...'
                : item.file_name.split('.')[0]
            }}
          </el-link>
        </el-tag>
      </template>
    </div>
    <slot name="lost_parts_claim_slot"></slot>
  </el-upload>
</template>
<script>
import putUploadAjax from '@/util/putUploadAjax'
import { uploadFn } from 'api/common'

export default {
  props: {
    actionUrl: {
      // 上传地址
      type: String,
      default: '/app/tool/upload_url'
    },
    data: {
      // 上传时需要携带的参数
      type: Object
    },
    fileFormat: {
      // 上传文件的格式 为空则可上传所有文件类型
      type: Array,
      default: () => []
    },
    fileSize: {
      // 上传文件时，单个文件的大小 单位是 M（兆）
      type: Number,
      default: 5
    },
    fileLimit: {
      // 上传文件的个数
      type: Number,
      default: 2
    },
    content: {
      default: ''
    },
    maxDisplayNum: {
      default: 10
    },
    showFile: {
      default: true
    },
    showBtn: {
      default: true
    },
    disabled: {
      default: false
    }
  },
  data() {
    return {
      uploadUrl: '',
      multiple: true,
      uploadHeaders: {},
      successFileList: []
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    putUploadAjax,
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(
          this.$t('730', {
            fileSize: this.fileSize
          })
        )
        return false
      }
      return new Promise((resolve, reject) => {
        uploadFn(this.actionUrl, {
          ...this.data,
          file_name: file.name,
          bucket_name: 'file'
        })
          .then(data => {
            file.prepareData = data.data
            this.uploadUrl = data.data.put_url
            this.uploadHeaders['Content-Type'] = data.data.content_type
            resolve(file)
          })
          .catch(() => {
            this.$message.error('retry later please')
            reject(file)
          })
      })
    },
    progressHandle() {},
    // 上传成功+
    successHandle(res, file) {
      this.successFileList.push({
        file_name: file.name,
        object_key: file.raw.prepareData.object_key,
        object_url: file.raw.prepareData.object_url
      })
      this.reset()
    },
    // 更新
    reset() {
      this.$nextTick(() => {
        this.$emit('success', this.successFileList)
      })
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err, file) {
      const index = this.$refs.upload.uploadFiles.findIndex(v => v.name === file.name)
      this.$refs.upload.uploadFiles.splice(index, 1)
      this.$message.error('upload error')
      throw err
    },
    exceedHandle() {
      this.$message.error(
        this.$t('731', {
          fileLimit: this.fileLimit
        })
      )
    },
    handleOpen(e) {
      e.stopPropagation()
    },
    // 删除
    handleRemove(e, item) {
      e.stopPropagation()
      this.$confirm(this.$t('732'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        confirmButtonClass: 'el-button--mini',
        cancelButtonClass: 'el-button--mini',
        type: 'warning'
      }).then(() => {
        this.successFileList.splice(
          this.successFileList.findIndex(v => v.object_url === item.object_url),
          1
        )
        this.$refs.upload.uploadFiles.splice(
          this.$refs.upload.uploadFiles.findIndex(v => v.name === item.file_name),
          1
        )
        this.reset()
      })
    }
  }
}
</script>
<style lang="less">
.upload-hide {
  .el-upload--picture-card {
    display: none;
  }
  .el-button {
    display: none;
  }
}
.fs-bi-upload {
  .el-upload {
    text-align: left;
  }
  .el-tag {
    margin-left: 20px;
  }
}
</style>
